import { AllItemResponse, AssetsDropDownResponseModel, GetItemForProductRequest, ItemResponse, ItemsDropDownDto, ItemsDropDownResponseModel } from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { BomItemRequest } from './dto/bom-item-request';
import { GetItemsRequest } from './dto/get-items.request';
import { ItemBySubcategory } from './dto/item-by-subcategory';
import { ItemsReqForCategoryId } from './dto/item-category.request';
import { ItemCodeRequest } from './dto/item-code.req';
import { ItemForBrandReq } from './dto/item-for-brand-request';
import { ItemDto } from './dto/item.dto';
import { ItemRequest } from './dto/item.request';
import { RmBomItemRequest } from './dto/rm-bom-item-request';
import { ItemsService } from './items.service';
import { plantIdRequest } from '../rm-rack-position/dto/plant-request';

@ApiTags('items')
@Controller('items')
export class ItemsController {
  constructor(
    private itemService: ItemsService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) { }

  /**
 * creates  a Item 
 * @param Item Item  DTO
 * @returns Item Response
 */
  @Post('/createItem')
  async createItem(@Body() itemDto: ItemDto, isUpdate: boolean = false, @Req() request: Request): Promise<ItemResponse> {
    try {
      return await this.itemService.createItem(itemDto, false, request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  /**
 * gets all the Value Item
 * @returns AllItemResponseModel which returns all the Value Item  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
 */

  @Post('/getAllItems')
  async getAllItems(): Promise<AllItemResponse> {
    try {
      return await this.itemService.getAllItems();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllItemResponse, error);
    }
  }

  /**
  * Activate Or De-Activate Value Item 
  * @param getSingleItem item  
  * @returns Value ItemResponse
  */
  @Post('/activateOrDeactivateItem')
  async activateOrDeactivateItem(@Body() itemReq: ItemRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.activateOrDeactivateItem(itemReq);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(ItemResponse, err);
    }
  }

  /**
    *  updates a  value Item 
    * @param Item Item DTO
    * @returns ItemResponse
    */
  @Post('/updateItem')
  async updateItem(@Body() itemDto: ItemDto, isUpdate: boolean = true, @Req() request: Request): Promise<ItemResponse> {
    try {
      return await this.itemService.createItem(itemDto, true, request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  /**
  *  get item at item category 
  * @param Item Item DTO
  * @returns ItemResponse
  */
  @Post('/getItemByCategoryId')
  async getItemByCategoryId(@Body() itemCatId: ItemsReqForCategoryId): Promise<ItemsDropDownResponseModel> {
    try {
      return await this.itemService.getItemsByCategoryId(itemCatId.itemCategoryId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getItemForCategoryAndSubCat')
  async getItemForCategoryAndSubCat(@Body() req: GetItemsRequest): Promise<ItemsDropDownResponseModel> {
    try {
      return await this.itemService.getItemForCategoryAndSubCat(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getItemById')
  async getItemById(@Body() itemReq: ItemRequest): Promise<ItemsDropDownDto> {
    try {
      return await this.itemService.getItemDataById(itemReq);
    } catch (err) {
      throw err;
    }
  }
  /**
    *  get item at item category 
    * @param Item Item DTO
    * @returns ItemResponse
    */
  @Post('/getItemForId')
  async getItemForId(@Body() req: ItemRequest) {
    try {
      return await this.itemService.getItemForId(req.itemId);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getItemForBom')
  async getItemForBom(@Body() bomItemreq: BomItemRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.getItemForBom(bomItemreq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  @Post('/getPouchItemForBom')
  async getPouchItemForBom(@Body() bomItemreq: BomItemRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.getPouchItemForBom(bomItemreq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  @Post('/getRmItemForBom')
  async getRmItemForBom(@Body() bomItemreq: RmBomItemRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.getRmItemForBom(bomItemreq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  

  @Post('/getTotalItemDataById')
  async getTotalItemDataById(@Body() itemReq: ItemRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.getTotalItemDataById(itemReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  @Post('/getTotalItemDataByCode')
  async getTotalItemDataByCode(@Body() itemReq: ItemCodeRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.getTotalItemDataByCode(itemReq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  @Post('/getItemsDropDownData')
  async getItemsDropDownData(): Promise<ItemsDropDownResponseModel> {
    try {
      return await this.itemService.getItemsDropDownData();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getPMItemsDropDownData')
  async getPMItemsDropDownData(): Promise<ItemsDropDownResponseModel> {
    try {
      return await this.itemService.getPMItemsDropDownData();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getItemForProduct')
  async getItemForProduct(@Body() bomItemreq: GetItemForProductRequest): Promise<ItemResponse> {
    try {
      return await this.itemService.getItemForProduct(bomItemreq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemResponse, error);
    }
  }

  @Post('/getItemForBrandAndSubCategory')
  async getItemForBrandAndSubCategory(@Body() req:ItemForBrandReq) :Promise<ItemsDropDownResponseModel> {
    try {
      return await this.itemService.getItemForBrandAndSubCategory(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getItemsForSubCategory')
  async getItemsForSubCategory(@Body() req:ItemForBrandReq) :Promise<ItemsDropDownResponseModel> {
    try {
      return await this.itemService.getItemsForSubCategory(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ItemsDropDownResponseModel, error);
    }
  }

  @Post('/getitemsforsubcategories')
  async getitemsforsubcategories(@Body() req:ItemForBrandReq) :Promise<CommonResponse> {
    try {
      return await this.itemService.getitemsforsubcategories(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }



   @Post('/getItemForItemId')
  async getItemForItemId(@Body() req:ItemRequest) :Promise<CommonResponse> {
    try {
      return await this.itemService.getItemForItemId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  @Post('/getAllGeneralItems')
  async getAllGeneralItems(@Body() req:ItemBySubcategory): Promise<AllItemResponse> {
    try {
      return await this.itemService.getAllGeneralItems(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllItemResponse, error);
    }
  }

  @Post('/getAssetDropdown')
  async getAssetDropdown(): Promise<AssetsDropDownResponseModel> {
    try {
      return await this.itemService.getAssetDropdown();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AssetsDropDownResponseModel, error);
    }
  }

  @Post('/getAllGeneralItem')
  async getAllGeneralItem(): Promise<AllItemResponse> {
    try {
      return await this.itemService.getAllGeneralItem();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllItemResponse, error);
    }
  }
}
